import React, { Component, Fragment } from 'react';

import {
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement
} from 'react-stripe-elements';

import { Grid } from '@material-ui/core';

import StripeElementWrapper from '../components/StripeElementWrapper';

class CreditCardFields extends Component {
  state = {
    cardNumber: false,
    cardCvc: false,
    cardExpiry: false
  }

  createStripeToken = () => {
    const { stripe, setStripeToken } = this.props;

    stripe.createToken({name: 'handy-checkout-flow'}).then(res => {
      const { error, token } = res;
      // TODO: display this error to the user
      if (error) return;

      setStripeToken(token.id);
    });
  }

  setComplete = (elementType, complete) => {
    this.setState({[elementType]: complete}, () => {
      const { setStripeToken } = this.props;
      const isComplete = Object.values(this.state).every(Boolean);
      if (!isComplete) return setStripeToken('');

      this.createStripeToken();
    });
  }

  render() {
    return (
      <Fragment>
        <Grid item xs={12}>
          <StripeElementWrapper
            label="Credit Card"
            autoComplete="cc-number"
            component={CardNumberElement}
            setComplete={this.setComplete}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <StripeElementWrapper
            label="CVC"
            autoComplete="cc-csc"
            component={CardCvcElement}
            setComplete={this.setComplete}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <StripeElementWrapper
            label="Exp. Date"
            autoComplete="cc-exp"
            component={CardExpiryElement}
            setComplete={this.setComplete}
          />
        </Grid>
      </Fragment>
    );
  }
}

export default CreditCardFields;
